module.exports = __webpack_public_path__ + "img/55.988abc01.jpg";